import * as type from '../actions/types';

const initialState = {
    services: [],
    loading: false,
    error: null,
}

export default function newService(state = initialState, action) {
    switch (action.type) {
        case type.GET_NEW_SERVICES_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_NEW_SERVICES_SUCCESS:
            return {
                ...state,
                loading: false,
                services: action.data,
            }
        case type.GET_NEW_SERVICES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}